import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { CarritoContext } from '../context/carritoContext'
import { calcularTotalItemConIva, calcularTotalItemSinIva } from '../helpers/calcularPrecioTotal'
import { obtenerPresupuestoItems, obtenerPublicacion } from '../servicios/compraService'
import { buscarPorId } from '../servicios/usuarioService'
import PasarelaPago from './PasarelaPago'

const Compra = () => {
  const [itemsCompra, setItemsCompra] = useState([])
  const [itemsPresupSinAlicuota, setItemsPresupSinAlicuota] = useState([])
  const [alicuotaPresupuesto, setAlicuotaPresupuesto] = useState(0)
  const location = useLocation()

  const { idPresupuestoComprar, idPublicacionComprar, items, cantidadCompra } =
    useContext(CarritoContext)

  const obtenerUsuario = async (idUsuario) => {
    const { data: usuarioTemp } = await buscarPorId(idUsuario)
    return usuarioTemp
  }

  const obtenerItems = async (idPresupuestoComprar, idPublicacionComprar, items) => {
    //si viene de presupuestos
    if (idPresupuestoComprar > 0) {
      const { data: itemsTemp } = await obtenerPresupuestoItems(
        parseInt(localStorage.getItem('idUsuario')),
        idPresupuestoComprar
      )
      setItemsPresupSinAlicuota(itemsTemp)
      setItemsCompra(itemsTemp.map((item) => ({ ...item, alicuota: alicuotaPresupuesto })))
    }
    //si viene de publicaciones
    else if (idPublicacionComprar > 0) {
      const { data: itemsTemp } = await obtenerPublicacion(
        parseInt(localStorage.getItem('idUsuario')),
        idPublicacionComprar
      )
      const pub = itemsTemp[0]
      const detalleState = location.state?.detalle || {}
      const preciosMayoristasState =
        detalleState?.preciosMayoristas ||
        detalleState?.preciosMayorista ||
        location.state?.preciosMayorista ||
        location.state?.preciosMayoristas ||
        []
      const pubConMayoristas = {
        ...pub,
        preciosMayoristas:
          Array.isArray(pub?.preciosMayoristas) && pub.preciosMayoristas.length > 0
            ? pub.preciosMayoristas
            : preciosMayoristasState
      }
      const usrVendedor = await obtenerUsuario(pub.idVendedor)

      const porcDcto = Number(pub.porcDcto || location.state?.porcDcto) || 0
      const tieneDescuento = Boolean(location.state?.tieneDescuento || porcDcto > 0)

      const toNumber = (v) => {
        const n = Number(v)
        return Number.isFinite(n) ? n : 0
      }

      const obtenerPrecioMayorista = (item, cantidad) => {
        let lista = []
        if (Array.isArray(item.preciosMayoristas) && item.preciosMayoristas.length > 0) {
          lista = item.preciosMayoristas
        } else if (Array.isArray(item.preciosMayorista) && item.preciosMayorista.length > 0) {
          lista = item.preciosMayorista
        } else if (item.precioUnitarioMayorista && item.cantidadMayorista) {
          lista = [
            {
              cantidad: item.cantidadMayorista,
              precioUnitario: item.precioUnitarioMayorista
            }
          ]
        }

        if (!lista.length) {
          return null
        }
        const tiers = lista
          .map((p) => ({
            cantidad: toNumber(p.cantidad),
            precioUnitario: toNumber(p.precioUnitario || p.precio)
          }))
          .filter((p) => p.cantidad > 0 && p.precioUnitario > 0)
          .sort((a, b) => b.cantidad - a.cantidad)
        return tiers.find((t) => cantidad >= t.cantidad) || null
      }

      const tier = obtenerPrecioMayorista(pubConMayoristas, cantidadCompra)
      const precioBase = tier ? tier.precioUnitario : toNumber(pub.precioUnitario)

      setItemsCompra([
        {
          ...pubConMayoristas,
          precioUnitario: precioBase,
          precioUnitarioSinDescuento: precioBase,
          porcDcto,
          tieneDescuento,
          ...location.state.imputacion,
          alicuota:
            items.filter((item) => item.idPublicacion === pub.idPublicacion)[0]?.alicuota ||
            pub.alicuota,
          cantidad: cantidadCompra,
          ...usrVendedor,
          valorTotalSinIva: calcularTotalItemSinIva({
            precioUnitario: precioBase,
            porcDcto,
            cantidad: cantidadCompra
          }),
          valorTotalConIva: calcularTotalItemConIva({
            precioUnitario: precioBase,
            porcDcto,
            cantidad: cantidadCompra,
            alicuota:
              items.filter((item) => item.idPublicacion === pub.idPublicacion)[0]?.alicuota ||
              pub.alicuota
          })
        }
      ])
    }
    //si viene del carrito
    else if (items.length > 0 && idPublicacionComprar === 0 && idPresupuestoComprar === 0) {
      setItemsCompra(
        items.map((item) => ({
          ...item,
          valorTotalSinIva: calcularTotalItemSinIva(item),
          valorTotalConIva: calcularTotalItemConIva(item)
        }))
      )
    }
  }

  useEffect(() => {
    obtenerItems(idPresupuestoComprar, idPublicacionComprar, items)
  }, [idPresupuestoComprar, idPublicacionComprar])

  useEffect(() => {
    if (itemsPresupSinAlicuota.length > 0) {
      const valor = Number(alicuotaPresupuesto)
      if (!isNaN(valor) && valor >= 0) {
        setItemsCompra(itemsPresupSinAlicuota.map((item) => ({ ...item, alicuota: valor })))
      }
    }
  }, [alicuotaPresupuesto])

  return (
    <>
      <br />
      {itemsPresupSinAlicuota.length > 0 && (
        <div className="row justify-content-center mb-3">
          <div className="col-auto d-flex align-items-center gap-2">
            <label htmlFor="alicuota-input" className="mb-0 fw-bold">
              % Alícuota IVA:
            </label>
            <input
              id="alicuota-input"
              type="number"
              className="form-control"
              style={{ width: '100px' }}
              value={alicuotaPresupuesto}
              onChange={(e) => setAlicuotaPresupuesto(e.target.value)}
              min="0"
              max="100"
            />
          </div>
        </div>
      )}
      <PasarelaPago itemsCompra={itemsCompra} />
    </>
  )
}

export default Compra
